import React from 'react';

import { Menu } from '@base-ui/react/menu';
import { Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  separator: {
    /**
     * Automatically avoid showing a separator as the first or last child of a menu, or immediately
     * adjacent to another separator. This lets us conditionally show or hide menu items without
     * worrying about orphaned separators.
     */
    '&:last-child, &:first-child, & + hr': {
      display: 'none',
    },
  },
}));

export function DeclarativeMenuSeparator() {
  const { classes } = useStyles();
  return <Menu.Separator render={<Divider className={classes.separator} sx={{ my: 0.5 }} />} />;
}
